import { ApolloError } from '@apollo/client'

const RECORD_NOT_FOUND = 'RECORD_NOT_FOUND'

// The backend raises this code both for a record that does not exist and for a record the contact
// is not allowed to read, because telling the two apart would leak the existence of the record.
export const isRecordNotFound = (error?: ApolloError) =>
  !!error?.graphQLErrors?.some((it) => it.extensions?.code === RECORD_NOT_FOUND)
